import { render, staticRenderFns } from "./Table.vue?vue&type=template&id=34a34ca2&scoped=true"
import script from "./Table.vue?vue&type=script&lang=js"
export * from "./Table.vue?vue&type=script&lang=js"
import style0 from "./Table.vue?vue&type=style&index=0&id=34a34ca2&prod&scoped=true&lang=scss"
import style1 from "./Table.vue?vue&type=style&index=1&id=34a34ca2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34a34ca2",
  null
  
)

export default component.exports